import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getArticles, deleteArticle, updateArticlesPagination } from '../../../store/actions/article/article_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../../ui_components/table_pagination';
import { REACT_ROUTES } from '../../../constants/react_routes';
import history from '../../../services/history';
import { roundNumber } from '../../../utils/helper_functions';
import ActionsComponent from '../../ui_components/actions_component';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    }
}));

const ArticlesTable = ({ articles: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getArticles({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.ARTICLE}/${uuid}`);
    }

    const handleDeleteArticle = (uuid) => {
        dispatch(deleteArticle(uuid))
            .then(() => dispatch(getArticles({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table" className={table}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Naziv</TableCell>
                        <TableCell align="center">Cena</TableCell>
                        <TableCell align="center">Dužina trajanja (u minutima)</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, name, price, duration, deletable }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">{ name }</TableCell>
                            <TableCell align="center">{ roundNumber(price) }</TableCell>
                            <TableCell align="center">{ duration }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteArticle(uuid)}
                                    deletable={deletable}
                                    label="uslugu"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updateArticlesPagination}
                 />
            </Table>
        </Paper>
    )
}

ArticlesTable.propTypes = {
    articles: PropTypes.object
}

const mapStateToProps = (state) => ({
    articles: state.articles
});

export default connect(mapStateToProps)(ArticlesTable);
